import { atomWithDefault } from 'jotai/utils';
import { Routes } from 'src/Routes.constants';

type AtomWithSerachParamsArgs<TFilters> = {
  route: Routes;
  urlSearchParamsMapperFn: (params: URLSearchParams) => TFilters;
  initialFilters: TFilters;
};

export const atomWithSerachParams = <TFilters>({
  route,
  urlSearchParamsMapperFn,
  initialFilters,
}: AtomWithSerachParamsArgs<TFilters>) =>
  atomWithDefault<TFilters>(() => {
    if (globalThis.location.pathname === route) {
      const params = new URLSearchParams(globalThis.location.search);
      return urlSearchParamsMapperFn(params);
    }

    return initialFilters;
  });
